document.addEventListener("turbo:load", setupAddressHandling);

function setupAddressHandling() {
  console.log('Load: spurimpact/user.js');

  const $country = $('#user_address_country');
  const $stateField = $('.address_state_field');
  const $stateInput = $('#user_address_state');

  $country.on('change', function () {
    if ($(this).val() !== "US") {
      $stateInput.prop('required', false);
      $stateField.hide();
    } else {
      $stateInput.prop('required', true);
      $stateField.show();
    }
  });

  // Trigger once on page load in case value is already set
  $country.trigger('change');
}